import { useState, useRef } from "react";
import styled from "styled-components";
import { OverflowMenu, OverflowMenuItem } from "@vfuk/core-overflow-menu";
import Button from "@vfuk/core-button";

const Container = styled.div`
  position: relative;
  width: 200px;
  display: flex;
  justify-content: flex-end;
`;

const OverflowMenuContainer = styled.div<{ itemLength: number }>`
  height: ${(props) => props.itemLength * 50}px;
  width: 200px;
  position: absolute;
  bottom: 50px;
`;

type Action = {
  text: string;
  id: string;
};

type ButtonOverflowMenuProps = {
  actions: Action[];
  onActionSelected: (actionId: string) => void;
  buttonText?: string;
};

const ButtonOverflowMenu = ({
  actions,
  onActionSelected,
  buttonText = "Actions",
}: ButtonOverflowMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refEl = useRef(null);

  return (
    <Container>
      <OverflowMenuContainer ref={refEl} itemLength={actions?.length}>
        <OverflowMenu
          isOpen={isOpen}
          onChange={onActionSelected}
          onClose={() => setIsOpen(false)}
          onOutsideClick={() => setIsOpen(false)}
          triggerRef={refEl}
          srText={buttonText}
        >
          {actions.map(({ text, id }) => (
            <OverflowMenuItem key={id} value={id} text={text} />
          ))}
        </OverflowMenu>
      </OverflowMenuContainer>
      <Button
        icon={{
          name: "more-android",
          justify: "left",
        }}
        text={buttonText}
        appearance="primary"
        onClick={() => setIsOpen(true)}
      />
    </Container>
  );
};

export default ButtonOverflowMenu;
